import conf from 'conf/config';
import { countries, obj_demo, notificaiton_demo_data, company_fake_data } from './static_data';


const my_profile = 
{
    get : async () =>
    {
        return new Promise(resolve => setTimeout(resolve(obj_demo), 1000));
    },
    set: async (obj) =>
    {
        return new Promise((resolve, reject) => setTimeout(reject({status:'error', msg:'not yet implemented'}), 1000));
    }
};

const change_password =
{
    set: async (obj) =>
    {
        return new Promise((resolve, reject) => setTimeout(reject({status:'error', msg:'not yet implemented'}), 1000));
    }
};

const notifications =
{
    get: async () =>
    {
        return new Promise(resolve => setTimeout(resolve(notificaiton_demo_data), 1000));
    }
};

const company =
{
    get: async () =>
    {
        return new Promise(resolve => setTimeout(resolve(company_fake_data), 1000));
    }
};

const AUTH =
{
    login: async (username, password) =>
    {
        return fetch(conf.endpoints.login, AJAX_CONF_FACTORY('POST',
        {
            login: username,
            password: password
        }));
    },
    impersonate: async (username, password, impersonate) =>
    {
        return fetch(conf.endpoints.login, AJAX_CONF_FACTORY('POST',
        {
            login: username,
            password: password,
            impersonate: impersonate
        }));
    },
    logout: async () =>
    {
        return fetch(conf.endpoints.logout, AJAX_CONF_FACTORY('POST'));
    },
    info: async () =>
    {
        return fetch(conf.endpoints.info, AJAX_CONF_FACTORY('POST'));
    },
    lost_password: async (user_id) =>
    {
        const tmp = conf.endpoints.lost_password.replace('{USERID}', user_id)
        return fetch(tmp, AJAX_CONF_FACTORY('POST'));
    },
    reset_user_password: async (user_id, token, new_password) =>
    {
        const tmp = conf.endpoints.lost_password.replace('{USERID}', user_id)
        return fetch(tmp, AJAX_CONF_FACTORY('POST',
        {
            reset_token: token,
            new_password: new_password
        }));
    },
    reset_onw_password: async (user_id, old_password, new_password) =>
    {
        const tmp = conf.endpoints.lost_password.replace('{USERID}', user_id)
        return fetch(tmp, AJAX_CONF_FACTORY('POST',
        {
            old_password: old_password,
            new_password: new_password
        }));
    },
    register_user: async (email, id_code) =>
    {
        const tmp = conf.endpoints.register_user;
        return fetch(tmp, AJAX_CONF_FACTORY('POST',
        {
            email: email,
            code: id_code
        }));
    }
};

const AJAX_CONF_FACTORY = (_method='GET', body=null) =>
{
    const METHODS = ['GET', 'POST', 'HEAD', 'DELETE'];
    const method = _method.toUpperCase();
    let json_body;
    let tmp = {
        method: method,
        cache: 'no-cache',
        credentials: "include",
        headers:
        {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
        }
    };
    if(!METHODS.includes(method))
    {
        console.error('invalid method');
        return null;
    }
    if(body !== null)
    {
        try
        {
            json_body = JSON.stringify(body);
            tmp.body = json_body
        }
        catch (error)
        {
            console.error(error);
            json_body = null;
            tmp = null
        }
    }
    return tmp;
}

export
{
    AJAX_CONF_FACTORY,
    AUTH,
    company,
    notifications,
    change_password,
    countries,
    my_profile
};
